import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.533 12.301 6.094 8.194c-.172-.205-.102-.482.156-.619a.667.667 0 0 1 .31-.075h6.878c.31 0 .561.2.561.447a.385.385 0 0 1-.094.247l-3.44 4.107c-.171.205-.52.26-.777.124a.52.52 0 0 1-.156-.124Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ArrowSmallDownIcon20.js.map